
import React, { Component } from 'react';
import { ToastContainer,toast,  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
import { Button, Badge } from 'reactstrap';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Arbor extends Component{

    constructor(props){
        super(props);
        this.state = {

            APIName: "Arbor Setting",
            APIUser: "",
            APIPass: "",
            LocationName: "",
            Division: "",
            loadingArbor: false,
            type: 'password',
            isAutenticated: true
        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleLocationName = this.handleLocationName.bind(this);
        this.handleDivision = this.handleDivision.bind(this);
        this.showHide = this.showHide.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }

    componentDidMount(){

        var ArborList = this.props.DataArbor;
        var Arbor = ArborList.find(x=> x.ALIAS === this.state.APIName);  
        var ArborValue = JSON.parse(Arbor.VALUE);       
        var UserName = ArborValue.UserName === null || ArborValue.UserName === undefined   ? "" :  ArborValue.UserName;
        var Pass = ArborValue.Password === null || ArborValue.Password === undefined   ? "" :  ArborValue.Password;
        var LocationName = ArborValue.Location === null || ArborValue.Location === undefined   ? "" :  ArborValue.Location;
        var Division = ArborValue.Division === null || ArborValue.Division === undefined   ? "" :  ArborValue.Division;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.LocationName = LocationName;
        stateCopy.Division = Division;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleLocationName(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.LocationName = value;
        this.setState(stateCopy);    
    }
    handleDivision(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Division = value;
        this.setState(stateCopy);    
    }

    ValidateSaveArbor(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var LocationName = this.state.LocationName;
        var Division = this.state.Division;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(LocationName === null || LocationName === "" || LocationName === undefined)
        {
            toast.error("Location field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Division === null || Division === "" || Division === undefined)
        {
            toast.error("Division field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;
    }
    SaveArbor(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var Division = this.state.Division;
        var LocationName = this.state.LocationName;
        var CompanyCode1 = this.props.CompanyCode;

        var ArborList = this.props.DataArbor;
        var Arbor = ArborList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveArbor();
        if(Validate === false)
        {
            return false;
        }
        
        this.setState({
            loadingArbor: true
        });

        var result = APIService.SaveArborSetting(CompanyCode1, email, UserName, Pass, LocationName, Division);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingArbor: false
                });
                var newList = {
                    ALIAS: Arbor.ALIAS,
                    COMPANY_CODE: CompanyCode1,
                    DIVISION: Division,
                    ID: Arbor.ID,
                    NAME: Arbor.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        Location: LocationName,
                        Division: Division,
                        Name:Arbor.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingArbor: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingArbor: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingArbor: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }
   
    render(){   
           
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2">
                                    <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.type}  onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>       
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                     
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Location(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="Location" id="Location" type="text" onChange={this.handleLocationName} value={ this.state.LocationName}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Division(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="division" id="division" type="text" onChange={this.handleDivision }  value={ this.state.Division}/>
                            </div>                          
                       </div>
                       <div className="row">             
                            <div className="col-2 offset-10" style={{ 'paddingTop': '200px'}} size="sm">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingArbor}
                                />
                                {
                                    this.state.loadingArbor
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveArbor(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveArbor(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Arbor;


// WEBPACK FOOTER //
// ./src/APIComponent/Arbor.jsx